import TableRow from "components/tableRow";

function Cricket({ title = null, events }) {
    return (
        <>
            <div className='relative w-full'>
                <p className='bg-[#18adc5] text-[#fff] text-[14px] font-bold h-[28px] leading-[19px] m-0 pl-[7px] pr-[10px] py-[6px] capitalize'>{title || "Cricket"}</p>
            </div>
            <TableRow events={events} event_type={4} />
        </>
    );
}

export default Cricket;
